import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/settings/line_user_accounts/Page";
import { useLineUserAccounts } from "~/hooks/vendors/useLineUserAccounts";

export const PATH = "/vendors/settings/line_user_accounts";

const LineUserAccounts: NextPage = () => {
	const { data: lineUserAccounts } = useLineUserAccounts().index();

	if (lineUserAccounts === null) {
		return null;
	}

	return (
		<>
			<NskHead title="LINEアカウント設定" />
			<Component lineUserAccounts={lineUserAccounts} />
		</>
	);
};

export default LineUserAccounts;
